import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import HomeHeader from "../../pages/home/HomeHeader";

const MainLayout = () => {
  const { pathname } = useLocation();

  return (
    <div className="min-h-screen flex flex-col justify-between">
      {pathname === "/" || pathname === "/accueil" ? (
        <HomeHeader />
      ) : (
        <Header />
      )}
      <Outlet />
      <Footer />
    </div>
  );
};

export default MainLayout;
